import { SelectMenuItem, Tooltip } from 'bold-ui'
import { SelectDownshiftMenuProps } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import theme from 'config/theme'
import { useFlags } from 'config/useFlagsContext'
import { useCallback } from 'react'

import { LotacoesCuidadoCompartilhadoSelectModel } from './LotacoesCuidadoCompartilhadoSelectField'

type LotacoesCuidadoCompartilhadoSelectFieldItemProps = SelectDownshiftMenuProps<
  LotacoesCuidadoCompartilhadoSelectModel
> & {
  item: LotacoesCuidadoCompartilhadoSelectModel
  isAtendimentoOdonto: boolean
}

const defaultDisabledMenuItemProps = {
  style: {
    cursor: 'not-allowed',
    '&:hover': {
      background: theme.pallete.primary.c100,
    },
  },
}

export function LotacoesCuidadoCompartilhadoSelectFieldItem(
  props: Readonly<LotacoesCuidadoCompartilhadoSelectFieldItemProps>
) {
  const {
    downshift: { getItemProps, itemToString },
    item,
    renderItem,
    isAtendimentoOdonto,
  } = props

  const { PILOTO_VINCULACAO_CUIDADO_ENABLED } = useFlags()

  const itemIsDisabled = useCallback((item: LotacoesCuidadoCompartilhadoSelectModel) => item?.hasAgendaFechada, [])

  const isDisabled = PILOTO_VINCULACAO_CUIDADO_ENABLED && itemIsDisabled?.(props.item) && !isAtendimentoOdonto

  const menuItemProps = isDisabled ? defaultDisabledMenuItemProps : { style: {} }
  const itemProps = getItemProps({ item, ...(isDisabled ? { disabled: true } : {}) })
  const setOpacity = isDisabled ? { style: { opacity: 0.5 } } : { style: {} }

  const renderedItem = <div {...setOpacity}>{renderItem ? renderItem(item) : itemToString(item)}</div>

  return (
    <SelectMenuItem {...menuItemProps} {...itemProps}>
      {isDisabled ? (
        <Tooltip text='Este profissional está com a agenda fechada.'>{renderedItem}</Tooltip>
      ) : (
        <>{renderedItem}</>
      )}
    </SelectMenuItem>
  )
}
